<template>
  <div>
    <select
      :class="selectClasses"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectField",
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Pilih salah satu",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((opt) => "value" in opt && "text" in opt);
      },
    },
    formValidate: {
      type: String,
      default: "",
    },
  },
  computed: {
    selectClasses() {
      return [
        "bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-2 px-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
        {
          "border-red-600": this.formValidate && !this.modelValue,
          "border-green-600": this.modelValue,
        },
      ];
    },
  },
};
</script>